import { render, staticRenderFns } from "./secondHandHouseDetail.vue?vue&type=template&id=d22d80f2&scoped=true&"
import script from "./secondHandHouseDetail.vue?vue&type=script&lang=js&"
export * from "./secondHandHouseDetail.vue?vue&type=script&lang=js&"
import style0 from "./secondHandHouseDetail.vue?vue&type=style&index=0&id=d22d80f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22d80f2",
  null
  
)

export default component.exports